import { Box, Flex, Grid, Text, Heading, Card, Button, IconButton, ScrollArea, Avatar, DropdownMenu } from '@radix-ui/themes';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import UserAvatar from '../common/UserAvatar';
import { activityService } from '../../services/activityService';
import CourseProgress from './CourseProgress';
import StudentPlanCheck from './StudentPlanCheck';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import MessageBox from '../common/MessageBox';


const StudentProgress = () => {
    const account = useSelector((state) => state.studentAccount);
    const subscriptions = account.subscriptions;
    console.log('subscriptions:::::::::::::', subscriptions);
    const [selectedSubscription, setSelectedSubscription] = useState(subscriptions[0]);
    const [activities, setActivities] = useState(null);
    const dispatch = useDispatch();
    const paymentDetails = useSelector(state => state.account.paymentDetails);
    console.log('paymentDetails>>>>>>>', paymentDetails);

    const handleSubscriptionClick = async (subscription) => {
        setSelectedSubscription(subscription);
        const activities = await activityService.getCourseActivities(subscription.course.id);
        console.log('activities', activities);
        setActivities(activities);
    };

    const handleQuizComplete = async (quiz) => {
        // reload activities
        const activities = await activityService.getCourseActivities(selectedSubscription.course.id);
        setActivities(activities);
    };

    if (paymentDetails?.status !== 'active') {
        return (
            <Box p="4">
                <StudentPlanCheck message="You need to subscribe to a plan to access your progress" />
            </Box>
        );
    }

    return (
        <Box>
            <Flex direction="column" gap="4" justify="start" align="start">
                {subscriptions.length < 1 ? (
                    <MessageBox type="warning" title="No Subscriptions" message="We cannot find any subscriptions on this account. Try subscribing to some courses" />
                ) : (
                    <Grid>
                        <ScrollArea type="scroll" scrollbars="horizontal">
                            <Flex gap="4" p="2" width={subscriptions.length * 140}>
                                {subscriptions.map((subscription) => (
                                    <Card
                                        key={subscription.id}
                                        style={{
                                            cursor: 'pointer',
                                            width: '120px',
                                            height: '140px',
                                            flexShrink: 0
                                        }}
                                        onClick={() => handleSubscriptionClick(subscription)}
                                    >
                                        <Flex direction="column" justify="center" gap="1" align="center" p="2">
                                            {subscription.course != null ? (
                                                <UserAvatar size="4" user={subscription.course?.teacher?.user || {}} fallback="AI" />
                                            ):(
                                                <Avatar size="4" color="orange" fallback="AI" />
                                            )}
                                            <Text size="1" weight="bold" align="center">{subscription.subject?.label || 'Unknown Subject'}</Text>
                                            {selectedSubscription?.id === subscription.id && <ChevronDownIcon />}
                                        </Flex>
                                    </Card>
                                ))}
                            </Flex>
                        </ScrollArea>
                    </Grid>
                )}

                {activities?.error ? (
                    <MessageBox type="error" title="Error fetching activities" message={activities.error} />
                ) : (
                    activities && <CourseProgress activities={activities} onQuizComplete={handleQuizComplete} />
                )}
            </Flex>
        </Box>
    );
};

export default StudentProgress;
